(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* Reveal on scroll */
  const observe = (root) => {
    const nodes = $$(".ss-reveal", root).filter((el) => !el.classList.contains("in"));
    if (!nodes.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      nodes.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    nodes.forEach((el) => io.observe(el));
  };
  observe(document);
  const revealSection = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    if (window.Shopify && window.Shopify.designMode) {
      scope.querySelectorAll(".ss-reveal").forEach((el) => el.classList.add("in"));
      return;
    }
    observe(scope);
  };
  document.addEventListener("shopify:section:load", (event) => {
    revealSection(event.target);
  });

  /* Campaign full-bleed hero (reference HTML) */
  const heroFb = document.querySelector("[data-ss-hero-fb]");
  if (heroFb) {
    const slides = [...heroFb.querySelectorAll(".ss-hero-fb__slide")];
    const dotsWrap = heroFb.querySelector("[data-ss-hero-dots]");
    const prevBtn = heroFb.querySelector("[data-ss-hero-prev]");
    const nextBtn = heroFb.querySelector("[data-ss-hero-next]");
    let idx = 0;
    let timer = null;
    const DUR = Number(heroFb.dataset.autoplay) || Number.parseInt(getComputedStyle(heroFb).getPropertyValue("--dur"), 10) || 6500;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const pauseHover = heroFb.dataset.pauseHover === "true";

    const dots = slides.map((_, i) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "ss-hero-fb__dot" + (i === 0 ? " is-on" : "");
      b.setAttribute("aria-label", `Go to slide ${i + 1}`);
      b.addEventListener("click", () => go(i));
      dotsWrap?.appendChild(b);
      return b;
    });

    const paint = (i) => {
      const s = slides[i];
      if (!s) return;
      heroFb.style.setProperty("--fg", s.dataset.fg || "#F6F1E9");
      heroFb.style.setProperty("--btnhover", s.dataset.hover || "#320914");
      heroFb.style.setProperty("--btn-bg", s.dataset.btnBg || s.dataset.fg || "#5A1226");
      heroFb.style.setProperty("--btn-text", s.dataset.btnText || s.dataset.hover || "#F8F4EC");
      heroFb.style.setProperty("--scrim", s.dataset.scrim || "1");
    };

    const go = (i) => {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      if (i === idx) return;
      slides[idx]?.classList.remove("is-on");
      dots[idx]?.classList.remove("is-on");
      idx = i;
      slides[idx].classList.add("is-on");
      const d = dots[idx];
      if (d) {
        d.style.animation = "none";
        void d.offsetWidth;
        d.style.animation = "";
        d.classList.add("is-on");
      }
      paint(idx);
      restart();
    };

    const restart = () => {
      clearInterval(timer);
      timer = null;
      if (reduceMotion || slides.length < 2) return;
      timer = setInterval(() => go(idx + 1), DUR);
    };

    prevBtn?.addEventListener("click", () => go(idx - 1));
    nextBtn?.addEventListener("click", () => go(idx + 1));
    document.addEventListener("keydown", (e) => {
      if (!heroFb.matches(":hover") && document.activeElement !== document.body) return;
      if (e.key === "ArrowRight") go(idx + 1);
      if (e.key === "ArrowLeft") go(idx - 1);
    });

    if (pauseHover) {
      heroFb.addEventListener("mouseenter", () => {
        heroFb.classList.add("is-paused");
        clearInterval(timer);
        timer = null;
      });
      heroFb.addEventListener("mouseleave", () => {
        heroFb.classList.remove("is-paused");
        restart();
      });
    }

    let x0 = null;
    let y0 = null;
    heroFb.addEventListener(
      "touchstart",
      (e) => {
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      },
      { passive: true }
    );
    heroFb.addEventListener(
      "touchend",
      (e) => {
        if (x0 == null) return;
        const dx = e.changedTouches[0].clientX - x0;
        const dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      },
      { passive: true }
    );

    paint(0);
    restart();
  }

  /* Sticky header + chrome offset for full-viewport hero */
  const header = $("#ss-header");
  const announce = document.querySelector(".ss-announce");
  const syncHeaderOffset = () => {
    const h = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const a = announce ? Math.ceil(announce.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--ss-header-offset", `${h}px`);
    document.documentElement.style.setProperty("--ss-announce-h", `${a}px`);
    document.documentElement.style.setProperty("--ss-chrome-offset", `${h + a}px`);
    document.body.style.setProperty("--header-height", `${h}px`);
  };
  if (header || announce) {
    syncHeaderOffset();
    const scrollRoot = document.querySelector(".page-wrapper") || window;
    const onScroll = () => {
      if (!header) return;
      const y = Math.max(window.scrollY || 0, scrollRoot === window ? 0 : scrollRoot.scrollTop || 0);
      header.classList.toggle("is-stuck", y > 10);
    };
    scrollRoot.addEventListener("scroll", onScroll, { passive: true });
    addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    syncHeaderOffset();
    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(syncHeaderOffset);
      if (header) ro.observe(header);
      if (announce) ro.observe(announce);
    }
    addEventListener("resize", syncHeaderOffset, { passive: true });
  }

  /* Mobile drawer */
  const navDrawer = $("#ss-drawer");
  const burger = $("#ss-burger");
  if (navDrawer && burger) {
    burger.addEventListener("click", () => navDrawer.classList.add("open"));
    $$("[data-ss-close]", navDrawer).forEach((el) =>
      el.addEventListener("click", () => navDrawer.classList.remove("open"))
    );
  }

  /* Monogram teaser (homepage) */
  const teaseText = $("#ss-tease-text");
  const teaseInput = $("#ss-tease-input");
  const teaseFonts = $("#ss-tease-fonts");
  if (teaseText && teaseInput) {
    teaseInput.addEventListener("input", () => {
      teaseText.textContent = (teaseInput.value || "SH").toUpperCase().slice(0, 2);
    });
  }
  if (teaseFonts && teaseText) {
    teaseFonts.addEventListener("click", (e) => {
      const b = e.target.closest(".ss-font-chip");
      if (!b) return;
      $$(".ss-font-chip", teaseFonts).forEach((c) => c.setAttribute("aria-pressed", c === b ? "true" : "false"));
      teaseText.style.fontFamily = b.dataset.font;
      teaseText.style.fontSize = b.dataset.font.includes("Figtree") ? "54px" : "72px";
    });
  }

  document.documentElement.classList.add("ss-cart-overlay");

  /* Etsy reviews carousel (PDP) */
  $$("[data-ss-rev-carousel]").forEach((root) => {
    const track = root.querySelector("[data-ss-rev-track]");
    const prevBtn = root.querySelector("[data-ss-rev-prev]");
    const nextBtn = root.querySelector("[data-ss-rev-next]");
    const meta = root.querySelector("[data-ss-rev-meta]");
    const slides = track ? [...track.querySelectorAll(".ss-rev-carousel__slide")] : [];
    const total = slides.length;
    if (!track || total < 1) return;

    const visibleAt = () => (window.matchMedia("(max-width: 1080px)").matches ? 1 : 3);

    const slideStep = () => {
      const slide = slides[0];
      if (!slide) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return slide.getBoundingClientRect().width + gap;
    };

    const currentIndex = () => {
      const step = slideStep();
      if (!step) return 0;
      return Math.min(total - 1, Math.max(0, Math.round(track.scrollLeft / step)));
    };

    const paint = () => {
      const vis = visibleAt();
      const idx = currentIndex();
      const end = Math.max(0, total - vis);
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= end;
      if (meta) {
        if (total <= 1) {
          meta.textContent = "1 review";
        } else if (vis === 1) {
          meta.textContent = `Review ${idx + 1} of ${total}`;
        } else {
          const from = idx + 1;
          const to = Math.min(total, idx + vis);
          meta.textContent = from === to ? `Review ${from} of ${total}` : `Reviews ${from}–${to} of ${total}`;
        }
      }
    };

    const go = (delta) => {
      const vis = visibleAt();
      const idx = currentIndex();
      const end = Math.max(0, total - vis);
      const next = Math.min(end, Math.max(0, idx + delta));
      track.scrollTo({ left: next * slideStep(), behavior: "smooth" });
    };

    prevBtn?.addEventListener("click", () => go(-1));
    nextBtn?.addEventListener("click", () => go(1));
    track.addEventListener("scroll", paint, { passive: true });
    addEventListener("resize", paint, { passive: true });
    paint();
  });

  /* PDP configurator. Re-run after the theme editor replaces this section. */
  const bootSignatureProduct = (scope) => {
  const scopeEl = scope && scope.querySelector ? scope : document;
  const form = scopeEl.querySelector("#ss-product-form");
  if (!form || form.dataset.ssBound === "1") return;
  form.dataset.ssBound = "1";

  const profile = form.dataset.profile || "default";
  const monoMax = Number(form.dataset.monoMax || 2);
  const previewShape = form.dataset.previewShape || "";
  const colourUpdatesPreview = form.dataset.colourUpdatesPreview !== "false";
  const forceUppercase =
    form.dataset.forceUppercase === "true" || profile === "atomiser" || profile === "keychain";
  const monoMultiline = profile === "perfume-male" || form.dataset.multiline === "true";
  const isNameProfile = !forceUppercase && profile !== "default";
  const isJewellery = profile === "jewellery-large" || profile === "jewellery-small";
  const usesJewelleryFonts = isJewellery || !!form.querySelector(".ss-fonts:not(.is-bottle-scripts):not(.is-lip-oil):not(.is-male):not(.is-signature) .ss-fbtn[data-name='Serif']");
  const usesBottleScriptFonts =
    profile === "perfume" ||
    profile === "perfume-gold" ||
    profile === "perfume-cylinder" ||
    !!form.querySelector(".ss-fonts.is-bottle-scripts, .ss-fonts.is-signature .ss-fbtn[data-name='Amoresa']");
  const usesLipOilFonts = profile === "lip-oil" || !!form.querySelector(".ss-fonts.is-lip-oil");
  const usesSignatureFonts = false;
  const usesMaleFonts = profile === "perfume-male" || !!form.querySelector(".ss-fonts.is-male");

  const moneyFormat = form.dataset.moneyFormat || "${{amount}}";
  const formatMoney = (cents) => {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","));
  };

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const cartAddUrl = () =>
    (window.Theme && Theme.routes && Theme.routes.cart_add_url) || `${root()}cart/add.js`;
  const cartUrl = () =>
    (window.Theme && Theme.routes && Theme.routes.cart_url) || `${root()}cart`;

  const coloursEl = $("#ss-colours");
  const colourProp = (coloursEl && coloursEl.dataset.colourProp) || "Leather Colour";
  const firstColour = $(".ss-colour[aria-pressed='true']") || $(".ss-colour");
  const firstOpt = form.querySelector(".ss-opt[aria-pressed='true']") || form.querySelector(".ss-opt");
  const fontRow = $("#ss-font-row");
  const firstFont = (fontRow && (fontRow.querySelector(".ss-fbtn[aria-pressed='true']") || fontRow.querySelector(".ss-fbtn"))) || $(".ss-fbtn[aria-pressed='true']") || $(".ss-fbtn");
  const isTwoLine = profile === "perfume-30" || form.dataset.twoLine === "true";
  const monoInput2 = $("#ss-mono-input-2");
  const monoMax2 = monoInput2
    ? Number(monoInput2.getAttribute("maxlength") || form.dataset.monoMax2 || 12)
    : profile === "perfume-30"
      ? 15
      : Number(form.dataset.monoMax2 || 12);
  const MONTSERRAT_FONT = "'Montserrat', sans-serif";
  const AMORESA_FONT = "'SS Amoresa', cursive";
  const BRITTANY_FONT = "'Brittany Signature', cursive";
  const SEASONS_FONT = "'The Seasons', serif";

  const defaultFont = () => {
    if (firstFont) return firstFont.dataset.font;
    if (isTwoLine) return BRITTANY_FONT;
    if (usesMaleFonts) return "'SS Male Font 1',serif";
    if (usesBottleScriptFonts) return AMORESA_FONT;
    if (usesLipOilFonts) return SEASONS_FONT;
    if (usesJewelleryFonts || isNameProfile || profile === "keychain") return "'Cormorant Garamond',serif";
    return "'Cormorant Garamond', serif";
  };
  const defaultFontName = () => {
    if (firstFont) return firstFont.dataset.name;
    if (isTwoLine) return "Brittany Signature";
    if (usesMaleFonts) return "Font 1";
    if (usesBottleScriptFonts) return "Amoresa";
    if (usesLipOilFonts) return "The Seasons";
    if (usesJewelleryFonts || isNameProfile) return "Serif";
    return "Serif";
  };

  const state = {
    profile,
    monoMax,
    monoMax2,
    isTwoLine,
    variantId: form.dataset.variantId,
    price: Number(form.dataset.price || 0),
    mono: profile === "keychain" ? "SA" : isNameProfile ? "" : "SH",
    mono2: "",
    font: defaultFont(),
    fontName: defaultFontName(),
    fontCase: (firstFont && firstFont.dataset.case) || (usesMaleFonts ? "upper" : ""),
    font2: isTwoLine ? MONTSERRAT_FONT : "'Cormorant Garamond',serif",
    fontName2: isTwoLine ? "Montserrat" : "Serif",
    colour: firstColour
      ? firstColour.dataset.colour
      : profile === "balm"
        ? "Ivory"
        : profile === "jewellery-large"
          ? "Cream"
          : profile === "jewellery-small"
            ? "Soft Pink"
            : profile === "keychain"
              ? "Burnt Orange"
              : profile === "perfume-cylinder"
                ? "White"
                : "Burgundy",
    hex: firstColour
      ? firstColour.dataset.hex
      : firstOpt && firstOpt.dataset.hex
        ? firstOpt.dataset.hex
        : profile === "balm"
          ? "#EDE4D2"
          : profile === "jewellery-large"
            ? "#F0E6D2"
          : profile === "jewellery-small"
            ? "#F3C9D4"
            : profile === "jewellery-tier"
              ? "#F3C9D4"
              : profile === "keychain"
                ? "#B34C21"
                : profile === "perfume-cylinder"
                  ? "#F5F0E6"
                  : "#5A1226",
    textColour:
      (firstColour && firstColour.dataset.text) ||
      (firstOpt && firstOpt.dataset.text) ||
      (profile === "jewellery-tier" ? "#B5546B" : ""),
    scent: "",
    engraveStyle: $("#ss-engrave-style .ss-opt[aria-pressed='true']")?.dataset.style || "",
    paintFill: "",
    colourProp,
    hasColour: Boolean(coloursEl),
    hasBalmScent: Boolean($("#ss-balm-scent-select") || $("#ss-balm-scents")),
    hasAtomiserScents: Boolean($("#ss-scents")),
    hasPerfumeScent: Boolean($("#ss-perfume-scent-select")),
    usesFontStyle: usesJewelleryFonts || usesBottleScriptFonts || usesLipOilFonts || usesMaleFonts || isTwoLine,
    managed: false,
    lines: [],
  };

  const LOCKED_LINE_FONTS = {
    serif: ["'Cormorant Garamond',serif", "Serif"],
    brittany: ["'Brittany Signature',cursive", "Brittany"],
    kunstler: ["'Kunstler Script',cursive", "Kunstler"],
    amoresa: ["'SS Amoresa',cursive", "Amoresa"],
    seasons: ["'The Seasons',serif", "The Seasons"],
    montserrat: ["'Montserrat',sans-serif", "Montserrat"],
    male1: ["'SS Male Font 1',serif", "Font 1"],
    male2: ["'SS Male Font 2',sans-serif", "Font 2"],
    male3: ["'SS Male Font 3',sans-serif", "Font 3"],
    male4: ["'SS Male Font 4',serif", "Font 4"],
  };

  const managedLines = form.dataset.managed === "true" ? $$("[data-ss-line]", form) : [];
  state.lines = managedLines.map((el) => ({
    el,
    input: el.querySelector("[data-ss-line-input]"),
    max: Number(el.dataset.max || 0),
    fontKey: el.dataset.font || "customer",
    size: Number(el.dataset.size || 0),
    uppercase: el.dataset.uppercase === "true",
    preview: el.dataset.preview || "",
    label: el.dataset.label || "",
    value: "",
  }));
  state.managed = state.lines.length > 0;

  const lineFontStack = (line) => {
    if (line.fontKey === "customer") return state.font;
    return (LOCKED_LINE_FONTS[line.fontKey] || LOCKED_LINE_FONTS.serif)[0];
  };
  const lineFontName = (line) => {
    if (line.fontKey === "customer") return state.fontName;
    return (LOCKED_LINE_FONTS[line.fontKey] || LOCKED_LINE_FONTS.serif)[1];
  };
  const lineIsUpper = (line) =>
    line.uppercase || line.fontKey.indexOf("male") === 0 || (line.fontKey === "customer" && (forceUppercase || state.fontCase === "upper"));
  const displayLine = (line) => {
    let text = (line.value || "").trim() || line.preview || "";
    if (lineIsUpper(line)) text = text.toUpperCase();
    return text;
  };

  const setProp = (name, value) => {
    let input = form.querySelector(`input[type="hidden"][name="properties[${name}]"]`);
    const trimmed = (value || "").toString().trim();
    if (!trimmed) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.disabled = false;
    input.value = trimmed;
  };

  const clearManagedProps = () => {
    form.querySelectorAll('input[type="hidden"][name^="properties[Line"]').forEach((input) => input.remove());
    [
      "Engraving",
      "Fragrance name",
      "Leather colour",
      "Script",
      "Personalisation",
      "Leather Colour",
      "Box Colour",
      "Lid Colour",
      "Font Style",
      "Line 2",
      "Line 2 font",
      "Balm Scent",
      "Fragrance",
      "Engraving Style",
      "Paint Filling",
    ].forEach((name) => {
      const input = form.querySelector(`input[type="hidden"][name="properties[${name}]"]`);
      if (input) input.remove();
    });
  };

  const syncProperties = () => {
    clearManagedProps();
    if (state.managed) {
      state.lines.forEach((line, i) => {
        const typed = (line.value || "").trim();
        setProp(`Line ${i + 1}`, typed);
        if (typed) setProp(`Line ${i + 1} font`, lineFontName(line));
        if (typed && line.size > 0) setProp(`Line ${i + 1} size`, `${line.size}px`);
      });
    } else {
    const txt = (state.mono || "").trim();
    const personalisation = txt || (isNameProfile ? "" : "SH");

    setProp("Personalisation", personalisation);

    if (state.usesFontStyle) {
      setProp("Font Style", state.fontName);
    } else if (state.fontName) {
      setProp("Script", state.fontName);
    }

    if (state.isTwoLine) {
      setProp("Line 2", (state.mono2 || "").trim());
      setProp("Line 2 font", state.fontName2);
    }
    }

    if (state.hasColour) setProp(state.colourProp, state.colour);
    if (state.engraveStyle) setProp("Engraving Style", state.engraveStyle);
    if (state.paintFill) setProp("Paint Filling", state.paintFill);

    if (state.hasBalmScent) {
      setProp("Balm Scent", state.scent);
    } else if (state.scent) {
      setProp("Fragrance", state.scent);
    }
  };

  const displayMono = () => {
    const raw = (state.mono || "").trim();
    if (raw) {
      const text = forceUppercase ? raw.toUpperCase() : raw;
      return state.fontCase === "upper" ? text.toUpperCase() : text;
    }
    if (profile === "perfume-30") return "Lauren";
    if (profile === "jewellery-large") return "ASHLEY";
    if (profile === "jewellery-small" || profile === "keychain") return "SA";
    if (usesMaleFonts) return "GROOM";
    if (usesSignatureFonts && state.fontCase === "upper") return "MADDY";
    return isNameProfile ? "Your Name" : "SH";
  };

  const displayMono2 = () => {
    const raw = (state.mono2 || "").trim();
    if (raw) return raw;
    if (profile === "perfume-30") return "BRIDESMAID";
    return "Your Role";
  };

  const shadeHex = (hex, amount) => {
    const raw = (hex || "").replace("#", "");
    if (raw.length !== 6) return hex;
    const n = parseInt(raw, 16);
    const mix = (c) => Math.max(0, Math.min(255, Math.round(c + (0 - c) * amount)));
    const r = mix((n >> 16) & 255);
    const g = mix((n >> 8) & 255);
    const b = mix(n & 255);
    return `#${[r, g, b].map((c) => c.toString(16).padStart(2, "0")).join("")}`;
  };

  const ENGRAVE_SHADOW =
    "0 1px 0 rgba(255,255,255,0.38), 0 -1px 1px rgba(0,0,0,0.28), 0 1px 2px rgba(0,0,0,0.12)";

  const fitPhotoType = (el, startSize, minSize = 11) => {
    el.style.whiteSpace = "nowrap";
    let size = startSize;
    el.style.fontSize = `${size}px`;
    const maxW = el.clientWidth;
    while (size > minSize && maxW && el.scrollWidth > maxW) {
      size -= 1;
      el.style.fontSize = `${size}px`;
    }
  };

  const LIGHT_HEX = new Set([
    "#EDE4D2",
    "#DBA9B0",
    "#A7C4D9",
    "#E8B4C4",
    "#B8A9C9",
    "#F0E6D2",
    "#F8F5EC",
    "#F3C9D4",
    "#B7D3E0",
    "#F5F0E6",
    "#FAE4E9",
    "#C8B8D8",
    "#D6336C",
    "#C2AC9A",
    "#9CADB7",
    "#AE8E93",
  ]);

  const isBottleProfile =
    profile === "perfume" ||
    profile === "perfume-gold" ||
    profile === "perfume-cylinder" ||
    profile === "perfume-male" ||
    profile === "perfume-30" ||
    (profile === "custom" && previewShape === "bottle");

  const paintBottleType = (el, text, isLine2 = false) => {
    const len = (text || "").replace(/\n/g, "").length;
    const inPhotoStack = el.closest(".ss-preview-engrave-stack.is-photo");
    el.style.textShadow = "none";
    el.style.textTransform = "none";
    el.style.fontWeight = profile === "perfume-male" || profile === "perfume-gold" ? "500" : "600";
    el.style.letterSpacing = isLine2 ? "0.08em" : profile === "perfume-male" ? "0.06em" : "0.04em";
    if (profile === "perfume-male") {
      el.style.color = "#F5F0E6";
    } else if (profile === "perfume-gold") {
      el.style.color = "#F7F0E4";
    } else {
      el.style.color = "#D4AF37";
    }
    if (isLine2) {
      if (profile === "perfume-30") {
        el.style.fontSize = len > 11 ? "10px" : len > 8 ? "11px" : "12px";
        el.style.fontWeight = "400";
        el.style.letterSpacing = "0.12em";
        el.style.textTransform = "uppercase";
        el.style.lineHeight = "1.15";
        el.style.textShadow = ENGRAVE_SHADOW;
        if (inPhotoStack) fitPhotoType(el, len > 11 ? 10 : 11, 8);
      } else {
        el.style.fontSize = len > 10 ? "11px" : len > 7 ? "12px" : "13px";
      }
      return;
    }

    const isSeasonsFont =
      usesBottleScriptFonts &&
      (state.fontName === "The Seasons" || (state.font || "").includes("The Seasons"));

    if (profile === "perfume-gold") {
      el.style.fontSize = isSeasonsFont
        ? len > 8
          ? "24px"
          : len > 6
            ? "28px"
            : "34px"
        : len > 7
          ? "18px"
          : len > 5
            ? "22px"
            : "26px";
      el.style.fontWeight = "400";
      el.style.letterSpacing = "0.03em";
      el.style.lineHeight = "1.05";
    } else if (profile === "perfume-30" || (profile === "custom" && form.dataset.twoLine === "true")) {
      /* Name ~2.5× role line — match listing bottle hierarchy */
      el.style.fontSize = len > 8 ? "28px" : len > 6 ? "38px" : "48px";
      el.style.fontWeight = "400";
      el.style.letterSpacing = "0.02em";
      el.style.lineHeight = "1";
      el.style.textTransform = "none";
      el.style.textShadow = ENGRAVE_SHADOW;
      if (inPhotoStack) fitPhotoType(el, len > 8 ? 34 : len > 6 ? 42 : 48, 22);
    } else if (profile === "perfume-male" || (profile === "custom" && monoMultiline)) {
      const lines = (text || "").split("\n").filter(Boolean).length || 1;
      const base = len > 6 ? 20 : len > 4 ? 26 : 32;
      el.style.fontSize = `${Math.max(16, base - (lines - 1) * 4)}px`;
      el.style.whiteSpace = "pre-line";
      el.style.lineHeight = "1.15";
    } else if (profile === "perfume-cylinder") {
      el.style.fontSize = isSeasonsFont
        ? len > 8
          ? "22px"
          : len > 6
            ? "28px"
            : "34px"
        : len > 7
          ? "14px"
          : len > 5
            ? "16px"
            : "18px";
      el.style.fontWeight = "400";
      el.style.letterSpacing = "0.03em";
      el.style.lineHeight = "1.05";
    } else if (profile === "perfume" || profile === "custom") {
      el.style.fontSize = isSeasonsFont
        ? len > 8
          ? "22px"
          : len > 6
            ? "26px"
            : "32px"
        : len > 7
          ? "15px"
          : len > 5
            ? "17px"
            : "20px";
      el.style.fontWeight = "400";
      el.style.letterSpacing = "0.03em";
      el.style.lineHeight = "1.05";
    } else {
      el.style.fontSize = len > 7 ? "15px" : len > 5 ? "17px" : "20px";
    }

    if (el.classList.contains("ss-preview-type")) {
      el.classList.toggle("is-seasons-font", isSeasonsFont);
    }

    if (!isLine2 && el.classList.contains("is-photo") && usesBottleScriptFonts && !isSeasonsFont) {
      el.style.lineHeight = "1.25";
      el.style.paddingBlock = "0.08em";
      const start = Number.parseFloat(el.style.fontSize) || 18;
      fitPhotoType(el, start, 9);
    }
  };

  const paint = () => {
    const preview = displayMono();
    $$("[data-ss-mono]").forEach((el) => {
      if (state.managed) return;
      el.textContent = preview;
      el.style.fontFamily = state.font;
      if (isBottleProfile && (el.classList.contains("ss-preview-type") || el.closest(".is-bottle"))) {
        paintBottleType(el, preview, false);
      } else if (profile === "keychain" && el.classList.contains("is-cube")) {
        el.style.fontSize = "48px";
        el.style.fontWeight = "500";
        el.style.letterSpacing = "0.08em";
        el.style.color = "#D4AF37";
        el.style.textShadow = "0 1px 0 rgba(255,255,255,0.28), 0 -1px 1px rgba(60,30,10,0.35)";
      } else if (profile === "atomiser" && el.classList.contains("is-round")) {
        el.style.fontSize = "48px";
        el.style.fontWeight = "500";
        el.style.letterSpacing = "1px";
        el.style.color = "#D4AF37";
        el.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
      } else if (isNameProfile) {
        const len = preview.length;
        const isOval = el.classList.contains("is-oval");
        const isPhoto = el.classList.contains("is-photo");
        if (isOval) {
          el.style.fontSize = len > 7 ? "26px" : len > 5 ? "32px" : "40px";
          el.style.fontWeight = "500";
          el.style.letterSpacing = "1px";
          el.style.color = "#D4AF37";
          el.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
        } else if (isPhoto) {
          const start = profile === "perfume-30" ? 34 : profile === "perfume-male" ? 16 : 18;
          fitPhotoType(el, start, profile === "perfume-30" ? 22 : 11);
        } else if (el.classList.contains("is-rect") && profile === "jewellery-large") {
          const script = state.fontName !== "Serif";
          let size = script ? 32 : 26;
          if (len > 11) size -= 10;
          else if (len > 8) size -= 8;
          else if (len > 5) size -= 2;
          el.style.fontSize = `${size}px`;
          el.style.fontWeight = "500";
          el.style.letterSpacing = "1px";
          el.style.color = "#D4AF37";
          el.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
        } else if (el.classList.contains("is-lid") && profile === "jewellery-tier") {
          let size = 26;
          if (len > 12) size = 16;
          else if (len > 8) size = 20;
          el.style.fontSize = `${size}px`;
          el.style.fontWeight = "500";
          el.style.letterSpacing = "1px";
          el.style.color = state.textColour || "#B5546B";
          el.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
        } else if (el.classList.contains("is-square") && profile === "jewellery-small") {
          const script = state.fontName !== "Serif";
          let size = script ? 32 : 26;
          if (len > 11) size -= 10;
          else if (len > 8) size -= 8;
          else if (len > 5) size -= 2;
          el.style.fontSize = `${size}px`;
          el.style.fontWeight = "500";
          el.style.letterSpacing = "1px";
          el.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
        } else {
          el.style.fontSize =
            len > 6 ? "clamp(14px,2.8vw,20px)" : len > 4 ? "clamp(16px,3vw,24px)" : "clamp(18px,3.5vw,28px)";
        }
      }
    });

    if (state.isTwoLine) {
      $$("[data-ss-mono-2]").forEach((el) => {
        const line2 = displayMono2();
        el.textContent = line2;
        el.style.fontFamily = state.font2;
        if (isBottleProfile) paintBottleType(el, line2, true);
        else if (profile === "perfume-30") fitPhotoType(el, 12, 10);
        else fitPhotoType(el, 17, 13);
      });
    }

    if (state.managed) {
      const total = state.lines.length;
      state.lines.forEach((line, i) => {
        const el = form.querySelector(`[data-ss-preview-line="${i}"]`);
        const text = displayLine(line);
        if (el) {
          el.textContent = text;
          el.style.fontFamily = lineFontStack(line);
          let size = line.size > 0 ? line.size : total === 1 ? 28 : total === 2 ? (i === 0 ? 32 : 14) : Math.max(12, 26 - total * 2);
          const len = text.replace(/\s/g, "").length;
          if (line.size > 0) {
            if (len > 12) size = Math.max(10, size - 6);
            else if (len > 8) size = Math.max(10, size - 3);
          } else if (len > 12) size -= 8;
          else if (len > 8) size -= 4;
          el.style.fontSize = `${Math.max(10, size)}px`;
          el.style.fontWeight = "400";
          el.style.letterSpacing = line.fontKey === "montserrat" ? "0.12em" : "0.02em";
          el.style.textTransform = lineIsUpper(line) ? "uppercase" : "none";
        }
        const countEl = line.el.querySelector("[data-ss-line-count]");
        if (countEl && line.max > 0) countEl.textContent = `${(line.value || "").length} / ${line.max}`;
        if (line.input) {
          line.input.style.fontFamily = lineFontStack(line);
          line.input.style.textTransform = lineIsUpper(line) ? "uppercase" : "none";
        }
      });
    }

    const selMono = $("#ss-sel-mono");
    if (selMono) {
      if (state.managed) {
        const first = state.lines[0];
        const live = first ? (first.value || "").trim() : "";
        selMono.textContent = live
          ? `${displayLine(first)} · ${lineFontName(first)}`
          : first
            ? first.preview || first.label || "Add your text"
            : "Add your text";
      } else {
      const live = (state.mono || "").trim();
      selMono.textContent = live
        ? `${forceUppercase ? live.toUpperCase() : live}${state.fontName ? ` · ${state.fontName}` : ""}`
        : profile === "perfume-30"
          ? "Lauren · Brittany Signature"
          : isNameProfile
            ? "Add your name"
            : `SH · ${state.fontName}`;
      }
    }

    const selMono2 = $("#ss-sel-mono-2");
    if (selMono2) {
      const live2 = (state.mono2 || "").trim();
      selMono2.textContent = live2 ? `${live2} · Montserrat` : profile === "perfume-30" ? "BRIDESMAID · Montserrat" : "Add second line";
    }

    const selColour = $("#ss-sel-colour");
    if (selColour) selColour.textContent = state.colour;

    const selVariant = $("#ss-sel-variant");
    const pressedOpt = form.querySelector(".ss-opt[data-variant-id][aria-pressed='true']");
    if (selVariant && pressedOpt) {
      selVariant.textContent = pressedOpt.childNodes[0]?.textContent?.trim() || pressedOpt.textContent.trim();
    }

    $$("[data-ss-option-sel]", form).forEach((el) => {
      const fieldset = el.closest("[data-ss-option-index]");
      if (!fieldset) return;
      const pressed = fieldset.querySelector(
        "[data-ss-option-values] [data-option-value][aria-pressed='true']"
      );
      if (pressed) {
        el.textContent = pressed.dataset.optionValue || pressed.dataset.colour || pressed.textContent.trim();
      }
    });

    const selFrag = $("#ss-sel-frag");
    if (selFrag && state.hasAtomiserScents) {
      const house = form.querySelector(".ss-opt[data-house='true'][aria-pressed='true']");
      selFrag.textContent = house && state.scent ? state.scent : house ? "Choose a scent" : "Fill with my own";
    }

    const selBalm = $("#ss-sel-balm-scent");
    if (selBalm) selBalm.textContent = state.scent || "Choose a scent";
    const selPerfume = $("#ss-sel-perfume-scent");
    if (selPerfume) selPerfume.textContent = state.scent || "Choose a scent";
    const selStyle = $("#ss-sel-engrave-style");
    if (selStyle && state.engraveStyle) selStyle.textContent = state.engraveStyle;

    const count = $("#ss-mono-count");
    if (count && state.monoMax > 0) count.textContent = `${(state.mono || "").length} / ${state.monoMax}`;
    const count2 = $("#ss-mono-count-2");
    if (count2) count2.textContent = `${(state.mono2 || "").length} / ${state.monoMax2}`;

    syncProperties();

    $$("[data-ss-price]").forEach((el) => (el.textContent = formatMoney(state.price)));
    const afterpay = $("#ss-afterpay");
    if (afterpay) afterpay.textContent = formatMoney(Math.round(state.price / 4));
    const sbMeta = $("#ss-sb-meta");
    if (sbMeta) {
      let label = "Personalised";
      if (state.managed) {
        const parts = state.lines.map((line) => (line.value || "").trim()).filter(Boolean);
        label = parts.length ? parts.join(" · ") : "Personalised";
      } else {
      const live = (state.mono || "").trim() || (isNameProfile ? "Personalised" : "SH");
      const live2 = state.isTwoLine ? (state.mono2 || "").trim() : "";
      label = live2 ? `${live} · ${live2}` : live;
      }
      sbMeta.textContent = state.hasColour ? `${label} · ${state.colour}` : label;
    }

    const disc = $("#ss-mono-overlay-span");
    if (disc && !disc.classList.contains("is-photo") && !disc.classList.contains("ss-preview-engrave-stack")) {
      const light = LIGHT_HEX.has(state.hex);
      const isOvalLid = disc.classList.contains("is-oval");
      const isSquareLid = disc.classList.contains("is-square");
      const isLid = disc.classList.contains("is-lid");
      const isCube = disc.classList.contains("is-cube");
      const isRoundLid = disc.classList.contains("is-round");
      const isBottle = disc.classList.contains("is-bottle");
      if (isBottle) {
        const lidColour =
          colourUpdatesPreview &&
          state.hasColour &&
          (state.colourProp || "").toLowerCase().includes("lid");
        if (lidColour) {
          disc.style.background = state.hex;
          disc.style.color = state.textColour || "#D4AF37";
          disc.style.border = "0";
          disc.style.boxShadow = "none";
          disc.style.textShadow = "none";
        } else if (profile === "perfume-gold") {
          disc.style.background = "#C5A46A";
          disc.style.color = "#F7F0E4";
          disc.style.border = "0";
          disc.style.boxShadow = "none";
          disc.style.textShadow = "none";
        } else if (profile === "perfume-male") {
          disc.style.background = "#9A9A9A";
          disc.style.color = "#F5F0E6";
          disc.style.border = "0";
          disc.style.boxShadow = "none";
          disc.style.textShadow = "none";
        } else {
          disc.style.background = "#F5F0E6";
          disc.style.color = "#D4AF37";
          disc.style.border = "0";
          disc.style.boxShadow = "none";
          disc.style.textShadow = "none";
        }
      } else if (profile === "jewellery-large") {
        disc.style.background = state.hex;
        disc.style.color = "#D4AF37";
        disc.style.border = "0";
        disc.style.boxShadow = "none";
        disc.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
      } else if (isCube) {
        disc.style.background = state.hex;
        disc.style.color = "#D4AF37";
        disc.style.border = "0";
        disc.style.boxShadow = "none";
        disc.style.textShadow = "0 1px 0 rgba(255,255,255,0.28), 0 -1px 1px rgba(60,30,10,0.35)";
      } else if (isLid) {
        disc.style.background = state.hex;
        disc.style.color = state.textColour || "#B5546B";
        disc.style.border = "0";
        disc.style.boxShadow = "none";
        disc.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
      } else if (isSquareLid) {
        disc.style.background = state.hex;
        disc.style.color = state.textColour || "#B5546B";
        disc.style.border = "0";
        disc.style.boxShadow = "none";
        disc.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
      } else if (isOvalLid || isRoundLid) {
        const gold = "#C9A227";
        disc.style.background = state.hex;
        disc.style.color = "#D4AF37";
        disc.style.border = `6px solid ${gold}`;
        disc.style.boxShadow = "none";
        disc.style.textShadow = "0 0 1px rgba(0,0,0,0.15)";
      } else {
        disc.style.background = state.hex;
        disc.style.color = state.textColour || (light ? "#5A1226" : "#DCBE8B");
        disc.style.boxShadow = `0 0 0 2px ${light ? "#B4915A" : "#DCBE8B"}`;
      }
    }
  };

  const variantMapEl = $("#ss-variant-map");
  let variantMap = [];
  if (variantMapEl) {
    try {
      variantMap = JSON.parse(variantMapEl.textContent || "[]");
    } catch (err) {
      variantMap = [];
    }
  }

  const getSelectedOptions = () => {
    const indexes = $$("[data-ss-option-index]", form)
      .map((el) => Number(el.dataset.ssOptionIndex))
      .sort((a, b) => a - b);
    return indexes.map((idx) => {
      const fieldset = form.querySelector(`[data-ss-option-index="${idx}"]`);
      const pressed = fieldset?.querySelector(
        "[data-ss-option-values] [data-option-value][aria-pressed='true']"
      );
      return pressed?.dataset.optionValue || "";
    });
  };

  const findVariantByOptions = (options) =>
    variantMap.find(
      (v) =>
        Array.isArray(v.options) &&
        v.options.length === options.length &&
        v.options.every((opt, i) => opt === options[i])
    );

  const applyVariant = (variant, sourceBtn) => {
    if (!variant) return;
    state.variantId = String(variant.id);
    state.price = Number(variant.price || state.price);
    const idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = state.variantId;
    const atc = form.querySelector('[name="add"]');
    if (atc) atc.disabled = !variant.available;
    const sbAtc = $("#ss-sb-atc");
    if (sbAtc) sbAtc.disabled = !variant.available;

    if (sourceBtn?.dataset.hex) {
      state.hex = sourceBtn.dataset.hex;
      state.textColour = sourceBtn.dataset.text || "";
      if (sourceBtn.dataset.colour) state.colour = sourceBtn.dataset.colour;
      state.hasColour = true;
    }

    const scentsWrap = $("#ss-scents-wrap");
    const houseBtn = form.querySelector(".ss-opt[data-house='true'][aria-pressed='true']");
    const isHouse = Boolean(houseBtn);
    if (scentsWrap) {
      scentsWrap.hidden = !isHouse;
      if (isHouse) requestAnimationFrame(() => syncScentOverflow($("#ss-scents"), scentsWrap, $("#ss-scents-hint")));
    }
    if (!isHouse && state.hasAtomiserScents) state.scent = "";
  };

  const syncFromOptions = (sourceBtn) => {
    if (!variantMap.length) return;
    const options = getSelectedOptions();
    const match = findVariantByOptions(options);
    if (match) applyVariant(match, sourceBtn);
    syncPaintFillVisibility();
    syncProperties();
    paint();
  };

  const getSelectedEngravingValue = () => {
    const fieldsets = $$("[data-ss-option-index]", form);
    for (const fieldset of fieldsets) {
      const name = (fieldset.dataset.ssOptionName || "").toLowerCase();
      if (!name.includes("engraving")) continue;
      const pressed = fieldset.querySelector(
        "[data-ss-option-values] [data-option-value][aria-pressed='true']"
      );
      return pressed?.dataset.optionValue || "";
    }
    const hardcoded = $("#ss-engrave-style .ss-opt[aria-pressed='true']");
    return hardcoded?.dataset.style || state.engraveStyle || "";
  };

  const isPaintVariantSelected = () => {
    const fieldsets = $$("[data-ss-option-index]", form);
    for (const fieldset of fieldsets) {
      const pressed = fieldset.querySelector(
        "[data-ss-option-values] [data-option-value][aria-pressed='true']"
      );
      const value = (pressed?.dataset.optionValue || "").toLowerCase();
      if (value.includes("paint")) return true;
    }
    return getSelectedEngravingValue().toLowerCase().includes("paint");
  };

  const syncPaintFillVisibility = () => {
    const wrap = $("#ss-paint-fill");
    if (!wrap) return;
    const isPaint = isPaintVariantSelected();
    wrap.hidden = !isPaint;
    const sel = $("#ss-sel-paint-fill");
    if (!isPaint) {
      state.paintFill = "";
      $$("[data-paint-fill]", wrap).forEach((x) => x.setAttribute("aria-pressed", "false"));
      if (sel) sel.textContent = "Choose a fill";
      return;
    }
    const pressed = wrap.querySelector("[data-paint-fill][aria-pressed='true']");
    state.paintFill = pressed?.dataset.paintFill || "";
    if (sel) sel.textContent = state.paintFill || "Choose a fill";
  };

  $$("[data-ss-option-values] [data-option-value]", form).forEach((btn) => {
    btn.addEventListener("click", () => {
      const fieldset = btn.closest("[data-ss-option-index]");
      if (!fieldset) return;
      $$("[data-option-value]", fieldset).forEach((x) =>
        x.setAttribute("aria-pressed", x === btn ? "true" : "false")
      );
      syncFromOptions(btn);
    });
  });

  const paintFillRow = $("#ss-paint-fill-opts");
  if (paintFillRow) {
    paintFillRow.addEventListener("click", (e) => {
      const b = e.target.closest("[data-paint-fill]");
      if (!b) return;
      $$("[data-paint-fill]", paintFillRow).forEach((x) =>
        x.setAttribute("aria-pressed", x === b ? "true" : "false")
      );
      state.paintFill = b.dataset.paintFill || "";
      const sel = $("#ss-sel-paint-fill");
      if (sel) sel.textContent = state.paintFill;
      syncProperties();
      paint();
    });
  }

  $$(".ss-opt[data-variant-id]", form).forEach((btn) => {
    btn.addEventListener("click", () => {
      $$(".ss-opt[data-variant-id]", form).forEach((x) => x.setAttribute("aria-pressed", x === btn ? "true" : "false"));
      state.variantId = btn.dataset.variantId;
      state.price = Number(btn.dataset.price || state.price);
      const idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.value = state.variantId;
      const scentsWrap = $("#ss-scents-wrap");
      const isHouse = btn.dataset.house === "true";
      if (scentsWrap) {
        scentsWrap.hidden = !isHouse;
        if (isHouse) requestAnimationFrame(() => syncScentOverflow($("#ss-scents"), scentsWrap, $("#ss-scents-hint")));
      }
      if (!isHouse && state.hasAtomiserScents) state.scent = "";
      if (btn.dataset.hex) {
        state.hex = btn.dataset.hex;
        state.textColour = btn.dataset.text || "";
        if (btn.dataset.colour) state.colour = btn.dataset.colour;
      }
      paint();
    });
  });

  if (variantMap.length) {
    const pressedColour = form.querySelector(
      "[data-ss-option-values] .ss-colour[aria-pressed='true'], [data-ss-option-values] .ss-opt[aria-pressed='true']"
    );
    syncFromOptions(pressedColour || null);
  }

  $$(".ss-scent:not(.ss-balm-scent)", form).forEach((btn) => {
    btn.addEventListener("click", () => {
      $$(".ss-scent:not(.ss-balm-scent)", form).forEach((x) =>
        x.setAttribute("aria-pressed", x === btn ? "true" : "false")
      );
      state.scent = btn.dataset.scent || "";
      paint();
    });
  });

  $$(".ss-balm-scent", form).forEach((btn) => {
    btn.addEventListener("click", () => {
      $$(".ss-balm-scent", form).forEach((x) => x.setAttribute("aria-pressed", x === btn ? "true" : "false"));
      state.scent = btn.dataset.scent || "";
      paint();
    });
  });

  const sanitizeMono = (raw) => {
    let val = raw.replace(/[^\w\s&.\-'\n]/g, "");
    if (monoMultiline) {
      const lines = val.split("\n").slice(0, 2);
      val = lines.join("\n");
    } else {
      val = val.replace(/\n/g, " ");
    }
    if (state.monoMax > 0) val = val.slice(0, state.monoMax);
    if (forceUppercase || state.fontCase === "upper") val = val.toUpperCase();
    return val;
  };

  const monoInput = $("#ss-mono-input");
  if (monoInput) {
    monoInput.addEventListener("input", (e) => {
      const val = sanitizeMono(e.target.value);
      state.mono = val;
      e.target.value = val;
      paint();
    });
  }

  if (fontRow) {
    fontRow.addEventListener("click", (e) => {
      const b = e.target.closest(".ss-fbtn");
      if (!b) return;
      $$(".ss-fbtn", fontRow).forEach((x) => x.setAttribute("aria-pressed", x === b ? "true" : "false"));
      state.font = b.dataset.font;
      state.fontName = b.dataset.name;
      state.fontCase = b.dataset.case || "";
      if (monoInput && state.fontCase === "upper" && state.mono) {
        state.mono = state.mono.toUpperCase();
        monoInput.value = state.mono;
      }
      if (state.managed && state.fontCase === "upper") {
        state.lines.forEach((line) => {
          if (line.fontKey === "customer" && line.value) {
            line.value = line.value.toUpperCase();
            if (line.input) line.input.value = line.value;
          }
        });
      }
      paint();
    });
  }

  if (state.managed) {
    state.lines.forEach((line) => {
      if (!line.input) return;
      line.input.addEventListener("input", (e) => {
        let val = e.target.value.replace(/[^\w\s&.\-']/g, "");
        if (line.max > 0) val = val.slice(0, line.max);
        if (lineIsUpper(line)) val = val.toUpperCase();
        line.value = val;
        e.target.value = val;
        paint();
      });
    });
  }

  if (monoInput2) {
    monoInput2.addEventListener("input", (e) => {
      let val = e.target.value.replace(/[^\w\s&.\-']/g, "");
      val = val.slice(0, state.monoMax2);
      state.mono2 = val;
      e.target.value = val;
      paint();
    });
  }

  if (coloursEl) {
    coloursEl.addEventListener("click", (e) => {
      const b = e.target.closest(".ss-colour");
      if (!b) return;
      $$(".ss-colour", coloursEl).forEach((x) => x.setAttribute("aria-pressed", x === b ? "true" : "false"));
      state.colour = b.dataset.colour;
      state.hex = b.dataset.hex;
      state.textColour = b.dataset.text || "";
      if (b.dataset.optionValue && variantMap.length) {
        syncFromOptions(b);
      } else {
        paint();
      }
    });
  }

  const balmSelect = $("#ss-balm-scent-select");
  if (balmSelect) {
    balmSelect.addEventListener("change", () => {
      state.scent = balmSelect.value;
      paint();
    });
  }
  const perfumeSelect = $("#ss-perfume-scent-select");
  if (perfumeSelect) {
    perfumeSelect.addEventListener("change", () => {
      state.scent = perfumeSelect.value;
      paint();
    });
  }
  const engraveRow = $("#ss-engrave-style");
  if (engraveRow) {
    engraveRow.addEventListener("click", (e) => {
      const b = e.target.closest(".ss-opt");
      if (!b) return;
      $$(".ss-opt", engraveRow).forEach((x) => x.setAttribute("aria-pressed", x === b ? "true" : "false"));
      state.engraveStyle = b.dataset.style || "";
      syncPaintFillVisibility();
      paint();
    });
  }

  const showStageImage = (src, srcset, alt) => {
    const stage = $("#ss-stage");
    if (!stage || !src) return;
    let img = $("#ss-stage-img");
    if (!img) {
      stage.querySelectorAll("video, iframe").forEach((el) => el.remove());
      img = document.createElement("img");
      img.id = "ss-stage-img";
      img.alt = alt || "";
      img.sizes = "(min-width: 900px) 45vw, 100vw";
      stage.prepend(img);
    }
    img.src = src;
    if (srcset) img.srcset = srcset;
  };

  $$(".ss-thumb").forEach((btn) => {
    btn.addEventListener("click", () => {
      $$(".ss-thumb").forEach((x) => x.setAttribute("aria-pressed", x === btn ? "true" : "false"));
      const stage = $("#ss-stage");
      if (!stage) return;
      if (btn.dataset.video === "true" && btn.dataset.mediaId) {
        const tpl = document.getElementById(`ss-media-${btn.dataset.mediaId}`);
        if (tpl) {
          stage.querySelectorAll("img, video, iframe").forEach((el) => el.remove());
          stage.appendChild(tpl.content.cloneNode(true));
        }
        return;
      }
      if (btn.dataset.src) {
        showStageImage(btn.dataset.src, btn.dataset.srcset, stage.dataset.imageAlt);
        stage.dataset.imageSrc = btn.dataset.src;
        if (btn.dataset.srcset) stage.dataset.imageSrcset = btn.dataset.srcset;
      }
    });
  });

  const syncScentOverflow = (list, wrap, hint) => {
    if (!list || !wrap) return;
    if (wrap.hidden) return;
    const overflowing = list.scrollHeight > list.clientHeight + 4;
    const atEnd = list.scrollTop + list.clientHeight >= list.scrollHeight - 8;
    wrap.classList.toggle("has-overflow", overflowing);
    wrap.classList.toggle("is-at-end", !overflowing || atEnd);
    if (hint) hint.hidden = !overflowing || atEnd;
  };

  const bindScentScroll = (listId, wrapId, hintId) => {
    const list = document.getElementById(listId);
    const wrap = document.getElementById(wrapId);
    const hint = document.getElementById(hintId);
    if (!list || !wrap || list.dataset.ssScrollBound === "1") return;
    list.dataset.ssScrollBound = "1";
    const update = () => syncScentOverflow(list, wrap, hint);
    list.addEventListener("scroll", update, { passive: true });
    addEventListener("resize", update);
    update();
  };

  bindScentScroll("ss-balm-scents", "ss-balm-scents-wrap", "ss-balm-scents-hint");
  bindScentScroll("ss-scents", "ss-scents-wrap", "ss-scents-hint");

  const stickyAtc = $("#ss-sb-atc");
  const mainAtc = form.querySelector('[type="submit"]');
  if (stickyAtc && mainAtc) {
    stickyAtc.addEventListener("click", () => {
      if (!mainAtc.disabled) mainAtc.click();
    });
  }

  const updateCartDot = (count) => {
    const cartDot = $("#ss-cart-dot");
    if (!cartDot) return;
    cartDot.textContent = String(count || 0);
    cartDot.hidden = !count;
  };

  const openCartDrawer = async () => {
    const themeDrawer = $("#cart-drawer");
    if (themeDrawer && typeof themeDrawer.open === "function") {
      themeDrawer.open();
      return;
    }
    const trigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (trigger) trigger.click();
  };

  const refreshCartDrawerSection = async (sectionsHtml) => {
    const sectionEl = document.getElementById("shopify-section-cart-drawer-section");
    if (!sectionEl || !sectionsHtml) return false;
    const tmp = document.createElement("div");
    tmp.innerHTML = sectionsHtml;
    const next =
      tmp.querySelector("#shopify-section-cart-drawer-section") ||
      tmp.querySelector("theme-drawer") ||
      tmp.firstElementChild;
    if (!next) return false;

    if (next.id === "shopify-section-cart-drawer-section") {
      sectionEl.replaceWith(next);
    } else {
      sectionEl.innerHTML = "";
      sectionEl.appendChild(next);
    }
    return true;
  };

  let submitting = false;
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (submitting) return;
    submitting = true;

    paint();
    syncProperties();

    if (state.hasBalmScent && !state.scent) {
      window.alert("Please choose a fragrance / flavour.");
      submitting = false;
      return;
    }

    const paintFillWrap = $("#ss-paint-fill");
    if (paintFillWrap && !paintFillWrap.hidden && !state.paintFill) {
      window.alert("Please choose a paint filling (Silver or Gold).");
      submitting = false;
      return;
    }

    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) {
      submitting = false;
      return;
    }

    if (mainAtc) mainAtc.disabled = true;
    if (stickyAtc) stickyAtc.disabled = true;

    const formData = new FormData();
    formData.append("id", idInput.value);
    formData.append("quantity", "1");

    form.querySelectorAll('input[name^="properties["]').forEach((input) => {
      if (input.disabled) return;
      if (input.type === "file") {
        if (input.files && input.files[0]) formData.append(input.name, input.files[0]);
        return;
      }
      if (!input.value || !String(input.value).trim()) return;
      formData.append(input.name, String(input.value).trim());
    });

    const sectionIds = new Set(["cart-drawer-section"]);
    document.querySelectorAll("[data-section-id]").forEach((el) => {
      if (el.dataset.sectionId) sectionIds.add(el.dataset.sectionId);
    });
    formData.append("sections", Array.from(sectionIds).join(","));
    formData.append("sections_url", window.location.pathname);

    try {
      const res = await fetch(cartAddUrl(), {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
        credentials: "same-origin",
      });
      const data = await res.json();

      if (!res.ok || data.status) {
        window.alert(data.description || data.message || "Could not add to cart");
        return;
      }

      if (data.sections && data.sections["cart-drawer-section"]) {
        await refreshCartDrawerSection(data.sections["cart-drawer-section"]);
      } else {
        const sectionRes = await fetch(`${window.location.pathname}?section_id=cart-drawer-section`);
        if (sectionRes.ok) await refreshCartDrawerSection(await sectionRes.text());
      }

      try {
        const cart = await fetch(`${cartUrl()}.js`, {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        }).then((r) => r.json());
        updateCartDot(cart.item_count);
      } catch (_) {
        updateCartDot(data.item_count || data.quantity || 1);
      }

      document.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true, detail: { source: "ss-product-form", data } })
      );

      await openCartDrawer();
    } catch (err) {
      console.error("[ss-product] add to cart failed", err);
      window.alert("Could not add to cart. Please try again.");
    } finally {
      submitting = false;
      if (mainAtc) mainAtc.disabled = false;
      if (stickyAtc) stickyAtc.disabled = false;
    }
  });

  syncPaintFillVisibility();
  paint();
  };

  window.ssBootSignatureProduct = bootSignatureProduct;
  bootSignatureProduct(document);
  document.addEventListener("shopify:section:load", (event) => {
    const section = event.target;
    if (!section || !section.querySelector || !section.querySelector("#ss-product-form")) return;
    bootSignatureProduct(section);
  });
})();
